;(function(Backbone, EG, _) {
  var userDefaults, phoneDefaults, companyUserDefaults, captchaDefaults, guestUserDefaults;

  phoneDefaults = {
    number: undefined,
    type_code: undefined
  };

  if (EG.isNA) {
    phoneDefaults = _.extend({}, phoneDefaults, {
      area_code: undefined,
      extension_number: undefined,
      country_prefix: undefined
    });
  }

  userDefaults = {
    type: 'NORMAL',
    email: undefined,
    login: undefined,
    single_sign_on_id: undefined,
    user_authentication_mode: undefined,
    personal_title_code: undefined,
    first_name: undefined,
    last_name: undefined,
    middle_name: undefined,
    regional_name: undefined,
    employee_id: undefined,
    travel_group_id: undefined,
    group_account_department_id: undefined,
    status_code: '1',
    mobile_phone: undefined,
    cost_center_1: undefined,
    cost_center_2: undefined,
    cost_center_4: undefined,
    cost_center_5: undefined,
    promo_mail: undefined,
    service_level_ids: undefined,
    invite_code: undefined,
    send_welcome_email: false,
    email_locale: undefined,
    user_business_info: undefined,
    date_of_birth: undefined,
    gender_code: 0,
    user_name: undefined,
    user_gender_code: undefined,
    user_title_code: undefined
  };

  guestUserDefaults = {
    type: 'GUEST',
    email: undefined,
    login: undefined,
    first_name: undefined,
    last_name: undefined,
    regional_name: undefined,
    personal_title_code: undefined,
    travel_group_id: undefined,
    group_account_department_id: undefined,
    status_code: '1',
    cost_center_2: undefined,
    cost_center_4: undefined,
    cost_center_5: undefined,
    send_welcome_email: false,
    guest_expiry_date: undefined,
    gender_code: 0,
    user_gender_code: undefined,
    user_title_code: undefined
  };

  captchaDefaults = {
    captcha_token: undefined,
    captcha_answer: undefined,
    captchaContent: undefined,
    nds_pmd: undefined,
    nds_id: undefined
  };

  userDefaults = _.extend({}, userDefaults, phoneDefaults);

  companyUserDefaults = {
    user_info: EG.Users.Utils.deepCloneObject(userDefaults),
    captcha_info: EG.Users.Utils.deepCloneObject(captchaDefaults)
  };

  EG.Users.Constants.user_defaults = userDefaults;

  EG.Users.Constants.company_user_defaults = companyUserDefaults;

  EG.Users.Constants.guest_user_defaults = guestUserDefaults;
})(Backbone, EG, _);
